import React from "react";
import './Refressal.css';

const Refressal = () => {
  return (
    <div className="redressal-ap row">
      <div className="redressal-wrap col-xl-12">

        {/* HERO */}
        <section className="redressal-hero">
          <h1>Grievance Redressal</h1>
          <p>Your voice matters. We’re here to listen, act, and resolve.</p>
          <p>At Garshya, we are committed to providing a transparent, fair, and responsive system for addressing customer concerns. This Grievance Redressal mechanism is designed in line with applicable Indian laws, including consumer protection and e-commerce guidelines.</p>
        </section>

        {/* SECTIONS */}
        <section className="redressal-section">

          <h2>Grievance Officer Details</h2>
          <p>As per regulatory requirements, you may contact our designated Grievance Officer:</p>
          <ul>
            <li><strong>Name:</strong> Amit Choudhary</li>
            <li><strong>Designation:</strong> Grievance Officer, Garshya</li>
            <li><strong>Email:</strong> <a href="mailto:grievance@garshya.com" className="redressal-email">grievance@garshya.com</a></li>
          </ul>

          <h2>How to Raise a Complaint</h2>
          <p>You can raise a grievance through any of the following channels:</p>
          <ul>
            <li>Email us at <a href="mailto:grievance@garshya.com" className="redressal-email">grievance@garshya.com</a></li>
            <li>Contact our support team via the Contact Us page</li>
            <li>Share complete details including:
              <ul>
                <li>Order ID (if applicable)</li>
                <li>Description of the issue</li>
                <li>Supporting documents or images (if required)</li>
              </ul>
            </li>
          </ul>

          <h2>Resolution Timeline</h2>
          <ul>
            <li>Acknowledgement: Within 48 hours of receiving your complaint</li>
            <li>Resolution: Within 7–10 business days from the date of acknowledgement</li>
          </ul>
          <p>In case of complex issues requiring additional verification, timelines may extend, and you will be informed accordingly.</p>

          <h2>Types of Grievances Covered</h2>
          <ul>
            <li>Order and delivery issues</li>
            <li>Payments and refunds</li>
            <li>Product quality or discrepancies</li>
            <li>Returns, cancellations, and service-related concerns</li>
            <li>Any other platform-related complaints</li>
          </ul>

          <h2>Escalation Process</h2>
          <ul>
            <li>If you are not satisfied with the initial resolution:
              <ul>
                <li>You may reply to the same email or request escalation</li>
                <li>Your concern will be reviewed at a higher level with priority handling</li>
              </ul>
            </li>
          </ul>

          <h2>Our Commitment</h2>
          <ul>
            <li>Fair and unbiased resolution</li>
            <li>Transparent communication</li>
            <li>Timely updates throughout the process</li>
          </ul>
          <p>We aim to resolve every concern with clarity, respect, and accountability.</p>

          <p>Garshya — Where your concerns are heard, valued, and resolved with care.</p>

        </section>

      </div>
    </div>
  );
};

export default Refressal;